import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type { GameCategoryModel, GameMerchantModel, GameModel } from "../../types/GameModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.GAME_DATA}`;

export interface Values {
	loading: boolean;

	categories: GameCategoryModel[];
	games: GameModel[];
	merchants: GameMerchantModel[];

	loadingFavoriteGames: boolean;
	favoriteGames: { game_id: string }[];
	makingFavorite: boolean;
}

export const initialState: IStateProps<Values> = {
	loading: false,

	categories: [],
	games: [],
	merchants: [],

	loadingFavoriteGames: false,
	favoriteGames: [],
	makingFavorite: false
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey,
	persistType: "indexedDB"
});
